export function compareVersions(a: string, b: string): number {
    const aParts = a.split('.').map(p => parseInt(p, 10) || 0);
    const bParts = b.split('.').map(p => parseInt(p, 10) || 0);

    const len = Math.max(aParts.length, bParts.length);

    for (let i = 0; i < len; i++) {
        const diff = (aParts[i] ?? 0) - (bParts[i] ?? 0);
        if (diff !== 0) return diff;
    }

    return 0;
}